<template>
  <div id="content-page">
    <div class="container-fluid">
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body class="pt-0">
              <b-row>
                <b-col
                  style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <b-row>
                    <b-col>
                      <div class="d-flex align-items-center mb-3 mb-lg-0">
                        <div
                          class="rounded-circle iq-card-icon iq-bg-primary mr-3"
                        >
                          <i class="ri-money-dollar-circle-line"></i>
                        </div>
                        <div class="text-left">
                          <h4>
                            {{ totalRevenue | formatCurrency | notAvailable }}
                          </h4>
                          <p class="mb-0">Total&nbsp;revenue</p>
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="d-flex align-items-center mb-3 mb-lg-0">
                        <div
                          class="rounded-circle iq-card-icon iq-bg-info mr-3"
                        >
                          <i class="ri-money-dollar-circle-fill"></i>
                        </div>
                        <div class="text-left">
                          <h4>
                            {{
                              weightedRevenue | formatCurrency | notAvailable
                            }}
                          </h4>
                          <p class="mb-0">Weighted&nbsp;revenue</p>
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="d-flex align-items-center mb-3 mb-lg-0">
                        <div
                          class="rounded-circle iq-card-icon iq-bg-danger mr-3"
                        >
                          <i class="ri-user-line"></i>
                        </div>
                        <div class="text-left">
                          <h4>{{ totalLeads | notAvailable }}</h4>
                          <p class="mb-0">Leads&nbsp; count</p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <h5 class="card-title">Filter by</h5>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-select
                          plain
                          v-model="selectedCluster"
                          :options="clusterOptions"
                          size="sm"
                          class="mb-3"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="null"
                              >select cluster</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-select
                          plain
                          v-model="selectedCompany"
                          :options="companyOptions"
                          size="sm"
                          class="mb-3"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="null"
                              >select company</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-select
                          plain
                          v-model="selectedStageId"
                          :options="stageOptions"
                          size="sm"
                          class="mb-3"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="null"
                              >select stage</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-select
                          plain
                          v-model="selectedCampaign"
                          :options="campaignOptions"
                          size="sm"
                          class="mb-3"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="null"
                              >select campaign</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </div>
      <b-row v-if="role === 'sales_manager'">
        <b-col>
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title d-inline">Filter by user</h4>
            </template>
            <template v-slot:body>
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="selectedUserIds"
                :reduce="(user) => user.id"
                label="email"
                :options="users"
              ></v-select>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6">
          <iq-card>
            <template v-slot:headerTitle>
              <h4>Leads count per stage</h4>
            </template>
            <template v-slot:body>
              <apexchart
                v-if="leadsCountChartData"
                height="350"
                type="bar"
                :options="leadsCountChartData.options"
                :series="leadsCountChartData.series"
              ></apexchart>
            </template>
          </iq-card>
        </b-col>
        <b-col lg="6">
          <iq-card>
            <template v-slot:headerTitle>
              <h4>Deal value sum per stage</h4>
            </template>
            <template v-slot:body>
              <b-table :items="dealValueSumTableData"></b-table>
              <!-- <apexchart
                v-if="dealValueSumChartData"
                height="200"
                type="bar"
                :options="dealValueSumChartData.options"
                :series="dealValueSumChartData.series"
              ></apexchart>-->
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <download-csv :data="exportData" name="leads.csv">
            <b-button
              v-bind:disabled="!exportData"
              variant="primary"
              class="mb-3 mr-1 float-right"
              >Download {{ exportData.length }} leads as CSV</b-button
            >
          </download-csv>
        </b-col>
      </b-row>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-table
                hover
                responsive
                :items="items"
                :fields="fields"
                class="mb-0 table-borderless"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(cluster)="data">
                  <LeadClusterBadge :cluster="data.value" />
                </template>
                <template v-slot:cell(contact)="data">
                  <router-link
                    v-if="$allowedRoute('leads.detail')"
                    :to="{
                      path: `/leads/${data.item.id}`,
                    }"
                  >
                    <b-button variant="link" style="color: var(--iq-primary)">
                      {{ data.value.first_name + " " + data.value.last_name }}
                    </b-button>
                  </router-link>
                  <h6 v-else>
                    {{ data.value.first_name + " " + data.value.last_name }}
                  </h6>
                  <!-- <DeletedBadge :deletedAt="data.item.deletedAt" /> -->
                </template>
                <template v-slot:cell(company)="data">
                  <h6>{{ data.value ? data.value.name : "-" }}</h6>
                </template>
                <template v-slot:cell(stage_id)="data">
                  <LeadStageBadge :stageId="data.value" />
                </template>
                <template v-slot:cell(campaign)="data">
                  <h6>{{ data.value.name }}</h6>
                </template>
                <template v-slot:cell(last_activity)="data">
                  <h6>{{ data.value | formatDate | notAvailable }}</h6>
                </template>
                <template v-slot:cell(priority_index)="data">
                  <h6>{{ data.value }}</h6>
                </template>
                <template v-slot:cell(number_of_clicks)="data">
                  <h6>{{ data.value }}</h6>
                </template>
                <template v-slot:cell(action)="data">
                  <!-- <b-button
                    v-if="!data.item.deletedAt"
                    @click="toDeleteItem = data.item.id"
                    variant="outline-danger"
                    size="sm"
                  >
                    <i class="ri-delete-bin-line m-0"></i>
                  </b-button> -->
                </template>
              </b-table>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row d-flex justify-content-center">
        <b-pagination
          value="3"
          size="md"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
      <b-modal
        id="delete-modal"
        :visible="!!toDeleteItem"
        title="Delete lead"
        @hidden="toDeleteItem = null"
      >
        <p>
          Lead
          <strong>{{ toDeleteLead ? `${toDeleteLead.id}` : null }}</strong>
          will be deleted.
        </p>
        <p>Are you sure?</p>
        <template #modal-footer="{}">
          <b-button
            size="sm"
            variant="outline-dark"
            @click="toDeleteItem = null"
            >Cancel</b-button
          >
          <b-button size="sm" variant="danger" @click="deleteItem(toDeleteItem)"
            >Delete</b-button
          >
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { core } from "../../../config/pluginInit";
import DeletedBadge from "./DeletedBadge";
import gql from "graphql-tag";
import LeadStageBadge from "./LeadStageBadge";
import LeadClusterBadge from "./LeadClusterBadge";
import IqCard from "../../../components/core/cards/iq-card.vue";
import ApexChart from "../../../components/core/charts/ApexChart.vue";
import { getAccountSync } from "../../../Utils/account";
const LIST_LEADS = gql`
  query listLeads(
    $where: leads_bool_exp!
    $order_by: [leads_order_by!]
    $limit: Int!
    $offset: Int!
  ) {
    leads_aggregate(order_by: $order_by, where: $where) {
      aggregate {
        totalCount: count
        sum {
          deal_value
        }
      }
    }
    leads(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
      id
      stage_id
      cluster
      priority_index
      number_of_clicks
      contact {
        id
        first_name
        last_name
        company {
          id
          name
        }
      }
      deal_value
      campaign {
        id
        name
      }
      last_activity
    }
  }
`;
const LIST_COMPANIES = gql`
  query listCompanies {
    companies {
      id
      name
    }
  }
`;
const LIST_CAMPAIGNS = gql`
  query listCampaigns {
    campaigns {
      id
      name
    }
  }
`;
const DELETE_LEAD = gql`
  mutation deleteLead($id: uuid!) {
    update_leads_by_pk(pk_columns: { id: $id }, _set: { deleted_at: "now()" }) {
      id
    }
  }
`;
const GET_AGGREGATION = gql`
  query(
    $qualifiedFilter: leads_bool_exp
    $contactedFilter: leads_bool_exp
    $metFilter: leads_bool_exp
    $negotiatingFilter: leads_bool_exp
    $wonFilter: leads_bool_exp
    $noneFilter: leads_bool_exp
  ) {
    qualified: leads_aggregate(where: $qualifiedFilter) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    contacted: leads_aggregate(where: $contactedFilter) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    met: leads_aggregate(where: $metFilter) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    negotiating: leads_aggregate(where: $negotiatingFilter) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    won: leads_aggregate(where: $wonFilter) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    none: leads_aggregate(where: $noneFilter) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
  }
`;
const LIST_AVAILABLE_USERS = gql`
  query {
    users(where: { role: { _eq: sales_person } }) {
      id
      email
      first_name
      last_name
    }
  }
`;
function aggregationAdditionalStageConditiona(stageId, additionalStageId) {
  const base = [
    {
      stage_id: {
        _eq: stageId
      }
    }
  ];
  if (additionalStageId !== null) {
    base.push({
      stage_id: {
        _eq: additionalStageId
      }
    });
  }
  return base;
}
const stageRevenueWeight = stage => {
  switch (stage) {
    case "none":
      return 0;
    case "qualified":
      return 0.2;
    case "contacted":
      return 0.4;
    case "met":
      return 0.6;
    case "negotiating":
      return 0.8;
    case "won":
      return 1;
    default:
      return 1;
  }
};
export default {
  name: "AnalyticsBusinessLeads",
  components: {
    LeadStageBadge,
    LeadClusterBadge,
    IqCard,
    DeletedBadge,
    ApexChart
  },
  data() {
    return {
      sortBy: "priority_index",
      sortDesc: true,
      leads: [],
      aggregation: null,
      totalLeads: null,
      totalRevenue: null,
      search: "",
      rows: null,
      perPage: 25,
      currentPage: 1,
      error: false,
      loading: false,
      selectedCluster: null,
      selectedStageId: null,
      selectedCompany: null,
      selectedCampaign: null,
      role: getAccountSync()?.defaultRole,
      fields: [
        { key: "cluster", title: "Cluster", sortable: true },
        { key: "contact", title: "Contact", sortable: false },
        { key: "company", title: "Company", sortable: false },
        { key: "stage_id", title: "Stage", sortable: true },
        { key: "campaign", title: "Campaign", sortable: false },
        { key: "last_activity", title: "Last Activity", sortable: true },
        { key: "priority_index", title: "Priority Index", sortable: true },
        { key: "number_of_clicks", title: "Number of Click", sortable: true },
        { key: "action", title: "Action", sortable: false }
      ],
      clusterOptions: [
        { value: "HOT", text: "Hot" },
        { value: "COLD", text: "Cold" }
      ],
      stageOptions: [
        { value: 100, text: "Qualified" },
        { value: 200, text: "Contacted" },
        { value: 300, text: "Met" },
        { value: 400, text: "Negotiating" },
        { value: 500, text: "Won" },
        { value: 0, text: "None" }
      ],
      toDeleteItem: null,
      exportData: [],
      selectedUserIds: []
    };
  },
  apollo: {
    leads: {
      query: LIST_LEADS,
      variables() {
        const vars = {
          where: {},
          // pagination
          limit: this.perPage,
          offset: this.currentPage * this.perPage - this.perPage
        };

        // sorting
        if (this.sortBy !== "") {
          vars.order_by = {
            [this.sortBy]: this.sortDesc ? "desc" : "asc"
          };
        }

        // filter
        const whereAttributes = [];
        if (this.search) {
          whereAttributes.push({
            contact: {
              _or: [
                {
                  first_name: {
                    _ilike: `%${this.search}%`
                  }
                },
                {
                  last_name: {
                    _ilike: `%${this.search}%`
                  }
                }
              ]
            }
          });
        }
        if (this.selectedCluster) {
          whereAttributes.push({
            cluster: {
              _eq: this.selectedCluster
            }
          });
        }
        if (this.selectedStageId !== null) {
          whereAttributes.push({
            stage_id: {
              _eq: this.selectedStageId
            }
          });
        }
        if (this.selectedCampaign) {
          whereAttributes.push({
            campaign_id: {
              _eq: this.selectedCampaign
            }
          });
        }
        if (this.selectedCompany) {
          whereAttributes.push({
            contact: {
              company_id: {
                _eq: this.selectedCompany
              }
            }
          });
        }
        if (this.selectedUserIds.length > 0) {
          whereAttributes.push({
            owner_id: {
              _in: this.selectedUserIds
            }
          });
        }
        if (whereAttributes.length > 0) {
          vars.where = {
            _and: whereAttributes
          };
        }

        // // default sort by PX
        // if (!vars.order_by) {
        //   vars.order_by = {};
        // }
        // vars.order_by["priority_index"] = "desc";

        return vars;
      },

      result({ data, loading, networkStatus }) {
        if (!loading) {
          this.rows = data.leads_aggregate.aggregate.totalCount;
          this.totalLeads = data.leads_aggregate.aggregate.totalCount;
          this.totalRevenue = data.leads_aggregate.aggregate.sum.deal_value;
        }
      }
    },
    companies: {
      query: LIST_COMPANIES
    },
    campaigns: {
      query: LIST_CAMPAIGNS
    },
    aggregation() {
      return {
        query: GET_AGGREGATION,
        variables() {
          return this.aggregationVars;
        },
        update: data => {
          console.log(data);
          return data;
        }
      };
    },
    users: {
      query: LIST_AVAILABLE_USERS
    }
  },
  computed: {
    items() {
      const d = this.leads.map(lead => {
        return {
          id: lead.id,
          cluster: lead.cluster,
          contact: lead.contact,
          company: lead.contact.company,
          stage_id: lead.stage_id,
          campaign: lead.campaign,
          last_activity: lead.last_activity,
          priority_index: lead.priority_index,
          number_of_clicks: lead.number_of_clicks
        };
      });
      return d;
    },
    companyOptions() {
      if (!this.companies) {
        return [];
      }
      return this.companies.map(i => ({
        value: i.id,
        text: i.name
      }));
    },
    campaignOptions() {
      if (!this.campaigns) {
        return [];
      }
      return this.campaigns.map(i => ({
        value: i.id,
        text: i.name
      }));
    },
    toDeleteLead() {
      if (!this.toDeleteItem) {
        return null;
      }
      const l = this.items.find(i => i.id === this.toDeleteItem);
      if (!l) {
        return null;
      }
      return l;
    },
    aggregationVars() {
      let vars = {};
      if (this.selectedCluster) {
        vars["cluster"] = {
          _eq: this.selectedCluster
        };
      }
      if (this.selectedCampaign) {
        vars["campaign_id"] = {
          _eq: this.selectedCampaign
        };
      }
      if (this.selectedCompany) {
        vars["contact"] = {
          company_id: {
            _eq: this.selectedCompany
          }
        };
      }
      if (this.selectedUserIds.length > 0) {
        vars["owner_id"] = {
          _in: this.selectedUserIds
        };
      }

      const qualifiedFilter = {
        ...vars,
        _and: aggregationAdditionalStageConditiona(100, this.selectedStageId)
      };
      const contactedFilter = {
        ...vars,
        _and: aggregationAdditionalStageConditiona(200, this.selectedStageId)
      };
      const metFilter = {
        ...vars,
        _and: aggregationAdditionalStageConditiona(300, this.selectedStageId)
      };
      const negotiatingFilter = {
        ...vars,
        _and: aggregationAdditionalStageConditiona(400, this.selectedStageId)
      };
      const wonFilter = {
        ...vars,
        _and: aggregationAdditionalStageConditiona(500, this.selectedStageId)
      };
      const noneFilter = {
        ...vars,
        _and: aggregationAdditionalStageConditiona(0, this.selectedStageId)
      };

      let finalVars = {};

      finalVars["qualifiedFilter"] = qualifiedFilter;
      finalVars["contactedFilter"] = contactedFilter;
      finalVars["metFilter"] = metFilter;
      finalVars["negotiatingFilter"] = negotiatingFilter;
      finalVars["wonFilter"] = wonFilter;
      finalVars["noneFilter"] = noneFilter;

      return finalVars;
    },
    leadsCountChartData() {
      if (!this.aggregation) {
        return null;
      }
      const keys = Object.keys(this.aggregation);
      const seriesCount = keys.map(k => this.aggregation[k].aggregate.count);
      this.leadsCountSeries = [
        {
          name: "Count",
          data: seriesCount
        }
      ];
      // this.updateChart();
      return {
        options: {
          chart: {
            id: "leads-count-chart"
          },
          xaxis: {
            categories: keys
          }
        },
        series: [
          {
            name: "Count",
            data: seriesCount
          }
        ]
      };
    },
    dealValueSumChartData() {
      if (!this.aggregation) {
        return null;
      }
      const keys = Object.keys(this.aggregation);
      const seriesSum = keys.map(
        k => this.aggregation[k].aggregate.sum.deal_value
      );
      return {
        options: {
          chart: {
            id: "deal-value-chart"
          },
          xaxis: {
            categories: keys
          }
        },
        series: [
          {
            name: "Sum",
            data: seriesSum
          }
        ]
      };
    },
    dealValueSumTableData() {
      if (!this.aggregation) {
        return null;
      }
      const keys = Object.keys(this.aggregation);
      const tableValues = keys.map(k => ({
        stage_id: k,
        count: this.aggregation[k].aggregate.count,
        sum: this.aggregation[k].aggregate.sum.deal_value || "-"
      }));
      return tableValues;
    },
    weightedRevenue() {
      if (!this.aggregation) {
        return null;
      }
      const keys = Object.keys(this.aggregation);
      const sum = keys.reduce(
        (acc, k) =>
          (acc +=
            this.aggregation[k].aggregate.sum.deal_value *
            stageRevenueWeight(k)),
        0
      );
      return sum;
    }
  },
  mounted() {
    core.index();
  },
  watch: {
    leadsCountChartData: function(val) {
      console.log("chart ref:", this.$refs.leadsCountChart);
      if (this.$refs.leadsCountChart) {
        this.$refs.leadsCountChart.$forceUpdate();
      }
    },
    leads: async function() {
      console.log("[EXPORT] recalculate exportable leads");
      const vars = {
        where: {},
        // pagination
        limit: this.perPage,
        offset: this.currentPage * this.perPage - this.perPage
      };

      // sorting
      if (this.sortBy !== "") {
        vars.order_by = {
          [this.sortBy]: this.sortDesc ? "desc" : "asc"
        };
      }

      // filter
      const whereAttributes = [];
      if (this.search) {
        whereAttributes.push({
          contact: {
            _or: [
              {
                first_name: {
                  _ilike: `%${this.search}%`
                }
              },
              {
                last_name: {
                  _ilike: `%${this.search}%`
                }
              }
            ]
          }
        });
      }
      if (this.selectedCluster) {
        whereAttributes.push({
          cluster: {
            _eq: this.selectedCluster
          }
        });
      }
      if (this.selectedStageId) {
        whereAttributes.push({
          stage_id: {
            _eq: this.selectedStageId
          }
        });
      }
      if (this.selectedCampaign) {
        whereAttributes.push({
          campaign_id: {
            _eq: this.selectedCampaign
          }
        });
      }
      if (this.selectedCompany) {
        whereAttributes.push({
          contact: {
            company_id: {
              _eq: this.selectedCompany
            }
          }
        });
      }
      if (this.selectedUserIds.length > 0) {
        whereAttributes.push({
          owner_id: {
            _in: this.selectedUserIds
          }
        });
      }

      if (whereAttributes.length > 0) {
        vars.where = {
          _and: whereAttributes
        };
      }

      const res = await this.$apollo.query({
        query: LIST_LEADS,
        variables: vars
      });

      if (res?.data) {
        const d = res.data.leads.map(l => {
          return {
            id: l.id,
            first_name: l?.contact?.first_name || "",
            last_name: l?.contact?.last_name || "",
            cluster: l?.cluster || "",
            stage_id: l?.stage_id || "",
            priority_index: l?.priority_index || "",
            number_of_clicks: l?.number_of_clicks || "",
            last_activity: l.last_activity,
            company: l?.contact?.company?.name || "",
            company_id: l?.contact?.company?.id || "",
            campaign: l?.campaign?.name || "",
            campaign_id: l?.campaign?.id || ""
          };
        });
        this.exportData = d;
      }
    }
  },
  methods: {
    async deleteItem(id) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_LEAD,
          variables: {
            id
          }
        });
        this.$toast.success(`Lead deleted`);
        this.toDeleteItem = null;
      } catch (error) {
        this.$toast.error(`Failed to delete lead : ${error.message}`);
      }
    }
  }
};
</script>
